export enum PartnerAndLocationRoleEnum {
  CONSIGNEE = 'CONSIGNEE',
  CONSIGNOR = 'CONSIGNOR',
  CARRIER = 'CARRIER',
  SUBCONTRACTOR = 'SUBCONTRACTOR',
  CLIENT = 'CLIENT',
  PLACEOFTAKINGOVER = 'PLACEOFTAKINGOVER',
  PLACEOFDELIVERY = 'PLACEOFDELIVERY',
  FREIGHTFORWARDER = 'FREIGHTFORWARDER',
}

export enum PartnerRoleEnum {
  CONSIGNOR = PartnerAndLocationRoleEnum.CONSIGNOR,
  CONSIGNEE = PartnerAndLocationRoleEnum.CONSIGNEE,
  CLIENT = PartnerAndLocationRoleEnum.CLIENT,
  CARRIER = PartnerAndLocationRoleEnum.CARRIER,
  SUBCONTRACTOR = PartnerAndLocationRoleEnum.SUBCONTRACTOR,
  FREIGHTFORWARDER = PartnerAndLocationRoleEnum.FREIGHTFORWARDER,
}

export enum LocationRoleEnum {
  PLACEOFTAKINGOVER = PartnerAndLocationRoleEnum.PLACEOFTAKINGOVER,
  PLACEOFDELIVERY = PartnerAndLocationRoleEnum.PLACEOFDELIVERY,
}
